import * as React from "react";
import { IMAGES } from "../../constants/IMAGES";
import { ButtonComponent } from "../global/ButtonComponent";
import { MODALS } from "./ModalContainer";
import { ModalContext } from "../../hooks/modalContext";

interface IPromos {
    isOpen: boolean
    onClose: () => void
}

const PromosContainer = (props: IPromos) => {
    const { onClose, isOpen } = props
    const { handleModalData } = React.useContext(ModalContext);
    const validateScape = (e: KeyboardEvent) => {
        if (isOpen && e.key === 'Escape') {
            close()
        }
    }
    const close = () => {
        onClose()
    }
    const setFormPromo = (subtitle: string, title: string, description: string) => {
        onClose()
        handleModalData({
            showModal: true,
            extraData: {
                title,
                description
            },
            modal: MODALS.PROMO_MODAL,
            title: 'ACCEDE A LA PROMOCIÓN',
            subtitle: subtitle
        })
    }

    React.useEffect(() => {
        window.addEventListener('keyup', validateScape)
        return () => {
            window.removeEventListener('keyup', validateScape)
        }
    }, [])

    if (!isOpen) {
        return null
    }
    return (
        <div
            className={`promos-view ${isOpen && 'promos-active'}`}
        >
            <div className="close-area" onClick={close} />
            <div
                className={`promo-container`}
            >
                <div>
                    <div className="text-primary strong size-5 p-b-s">
                        Auto por un mes
                    </div>
                    <div className="flex-row flex-no-wrap">
                        <div className="flex-column">
                            <div className="bg-gray bg-lighten-4 radius-50 p-all flex-row">
                                <img src={IMAGES.CALENDAR} alt="" />
                            </div>
                        </div>
                        <div className="flex-column p-l">
                            Alquila un auto por un mes y obtén <strong>el 40% de descuento</strong>
                        </div>
                    </div>
                    <div className="flex-row flex-end p-t-s">
                        <ButtonComponent
                            buttonText="Adquirir esta promoción"
                            buttonType="primary"
                            onClick={() => setFormPromo(
                                'AUTO POR UN MES',
                                'Renta un auto por un mes y obtén el 40% de descuento',
                                'Por favor completa el siguiente formulario para generar una pre reserva y acceder a la promoción, uno de nuestros asesores te contactará'
                            )}
                        />
                    </div>
                </div>
                <div className="p-t">
                    <div className="text-primary strong size-5 p-b-s">
                        El séptimo día es gratis
                    </div>
                    <div className="flex-row flex-no-wrap">
                        <div className="flex-column">
                            <div className="bg-gray bg-lighten-4 radius-50 p-all flex-row">
                                <img src={IMAGES.PROMO7} alt="" />
                            </div>
                        </div>
                        <div className="flex-column p-l">
                            Paga el alquiler de 6 días y recibe <strong>7 días</strong>
                        </div>
                    </div>
                    <div className="flex-row flex-end p-t-s">
                        <ButtonComponent
                            buttonText="Adquirir esta promoción"
                            buttonType="primary"
                            onClick={() => setFormPromo(
                                'PAGA 6 DÍAS RECIBE 7',
                                'Recibe el séptimo día gratis',
                                'Por favor completa el siguiente formulario para generar una pre reserva y acceder a esta promoción, alquila un vehículo por 6 días y recibe el séptimo día gratis, uno de nuestros asesores te contactará'
                            )}
                        />
                    </div>
                </div>
                <div className="p-t">
                    <div className="text-primary strong size-5 p-b-s">
                        El quinto día es gratis
                    </div>
                    <div className="flex-row flex-no-wrap">
                        <div className="flex-column">
                            <div className="bg-gray bg-lighten-4 radius-50 p-all flex-row">
                                <img src={IMAGES.PROMO7} alt="" />
                            </div>
                        </div>
                        <div className="flex-column p-l">
                            Renta 4 dias y recibe <strong>5 días</strong>
                        </div>
                    </div>
                    <div className="flex-row flex-end p-t-s">
                        <ButtonComponent
                            buttonText="Adquirir esta promoción"
                            buttonType="primary"
                            onClick={() => setFormPromo(
                                'PAGA 6 DÍAS RECIBE 7',
                                'Recibe el séptimo día gratis',
                                'Por favor completa el siguiente formulario para generar una pre reserva y acceder a esta promoción, alquila un vehículo por 6 días y recibe el séptimo día gratis, uno de nuestros asesores te contactará'
                            )}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default PromosContainer